import { IDashboardLearnerInfo } from 'components/admin/dashboard/types';
import safeFetch from 'lib/requests/fetch';
import { ISearchResult } from 'lib/types';
import { ILocation, UserProfileRole } from 'lib/types/user';
import _ from 'lodash';
import { IAutomatedSchedulerPopulationPayload } from '../training-campaigns/scheduler/api';

export interface IActiveLearnerSearchPayload {
  userIdsFilter?: {
    userIds: number[];
    exclude?: boolean;
  };
  attributes?: IAttributesPayload;
  hasEmail?: boolean;
  limit: number;
  offset: number;
  userSearchTerm?: string;
}

export interface IAttributesPayload {
  customCategoryValues?: string[];
  departments?: string[];
  employeeTypes?: string[];
  locations?: ILocation[];
  roles?: UserProfileRole[];
}

export const searchLearners = <P, T>(endpoint: string, payload: P) =>
  safeFetch<ISearchResult<T>>(endpoint, {
    method: 'POST',
    body: JSON.stringify(payload),
  });

export const searchActiveTeamMembers = _.partial(
  searchLearners<IActiveLearnerSearchPayload, IDashboardLearnerInfo>,
  '/admin/dashboard/search-active-learners'
);

export const getPopulationUserIds = (
  payload: IAutomatedSchedulerPopulationPayload
) =>
  safeFetch<number[]>('/admin/dashboard/scheduling/get-population-member-ids', {
    method: 'POST',
    body: JSON.stringify(payload),
  });

export interface IAssignmentPopulationUserIdsPayload {
  attributes?: IAttributesPayload;
  userIdsFilter?: {
    userIds: number[];
    exclude?: boolean;
  };
}

export const getEnrolledUserIds = (
  automatedSchedulerConfigId: number,
  payload: IAssignmentPopulationUserIdsPayload
) =>
  safeFetch<number[]>(
    `/admin/dashboard/automated-scheduler/${automatedSchedulerConfigId}/enrolled-user-ids`,
    {
      method: 'POST',
      body: JSON.stringify(payload),
    }
  );
